import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormControl, Validators, FormGroup } from '@angular/forms';
import { SignInRequestVM } from '../../../models/SignInRequestVM';
import { BaseComponent } from '../../base/base.component';
import { AuthResponseVM, AccountStatus } from '../../../models';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'LoginComponent',
  templateUrl: './login.component.html'
})
export class LoginComponent extends BaseComponent implements OnInit {

  model: SignInRequestVM;
  myForm: FormGroup;
  accountLocked: boolean = false;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private authService: AuthService
  ) {
    super(route);
    this.model = new SignInRequestVM();
  }

  ngOnInit(): void {
    this.myForm = this.fb.group({
      username: new FormControl('', [Validators.email, Validators.required]),
      password: new FormControl('', Validators.required)
    });
  }

  onSubmit(): void {
    this.hideMessageBox();
    if (this.myForm.valid) {
      this.emitDisplayLoadingDialog(true);
      this.authService.login(this.model)
        .subscribe(
          (returnValue) => this.signinResult(returnValue),
          error => { },
          () => { this.emitDisplayLoadingDialog(false); }
        );
    }
  }

  signinResult(response: AuthResponseVM) {
    if (response.accountStatus == AccountStatus.active && response.jwt != null) {
      localStorage.setItem('authToken', response.jwt);
      this.router.navigateByUrl('/dashboard');
    }
    else {
      this.model.password = '';
      this.showAlertBox(response.message, 3);
      this.accountLocked = (response.accountStatus == 203);
      window.scrollTo(0, 0);
    }
  }
}
